<a [routerLink]="[baseRoute, instructor.id]">
    <img
    class="instructor-image"
    [alt]="instructor?.firstName"
    src="{{ getInstructorDefaultMedia(instructor.medias) }}"
    >
    <div>
        <h5 class="instructor-title pt-2 m-0">{{ instructor.firstName + ' ' + instructor.lastName }}</h5>
        <div class="instructor-details">
            <div class="instructor-rating-review mr-3">
                <mat-icon>star</mat-icon>
                <div class="instructor-rating mr-1">{{ instructor.rating? (instructor.rating | number: '1.0-1'): 0 }}</div>
                <div class="instructor-review-count">({{ instructor.reviewCount }})</div>
            </div>
            <div class="instructor-address">
                <mat-icon>lense</mat-icon>
                {{ instructor?.regions[0]?.name }}
                <span *ngIf="instructor?.regions?.length>1">+{{ instructor.regions.length - 1 }}</span>
            </div>
        </div>
        <div class="instructor-courses-services">
            <div class="instructor-course-count">
                {{instructor.activeSchedules}}
                <span>{{ 'kurs' }}</span>
            </div>
        </div>
    </div>
</a>
